'use strict';

/**
 * View for rendering the sets
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var CompositeUploadView = require('base/Colido.CompositeUploadView');
var AssetUploadListItemView = require('./asset-upload-list-item');

var template = require('../../templates/components/asset-upload-list.hbs');

var AssetUploadListView = CompositeUploadView.extend({
    template: template,

    childView: AssetUploadListItemView,

    childViewContainer: '.assets-list',

    ui: {
        container: '.image-list-container',
        dismissAll: '[data-action="dismiss-all"]',
    },

    events: {
        'click @ui.dismissAll': 'dismissAll',
    },

    collectionEvents: {
        'add remove reset': 'updateView',
    },

    onRender: function() {
        CompositeUploadView.prototype.onRender.apply(this, arguments);

        this.setMaxFilesCount(App.user.get('licenseImages'));
        this.setSpaceLeft(App.user.get('spaceInBytesLeft'));

        this.listenTo(App.user, 'change', function(){
            this.setMaxFilesCount(App.user.get('licenseImages'));
            this.setSpaceLeft(App.user.get('spaceInBytesLeft'));
        });

        this.setCurrentFilesCount(this.collection.length);
    },

    onBeforeDestroy: function() {
        this.stopListening(App.user);
    },

    updateView: function() {
        this.setCurrentFilesCount(this.collection.length);

        if (this.collection.length > 0) {
            this.$('.image-list-container').addClass('has-images');
        } else {
            this.$('.image-list-container').removeClass('has-images');
        }

        this.trigger('change');
    },

    getTitle: function() {
        var field = this.getOption('field');

        return field.label || App.t('collection::object:details:assets:label');
    },

    dismissAll: function(event) {
        this.collection.reset();
    },
});

module.exports = AssetUploadListView;